<script setup>
import { defineProps, ref } from 'vue';
import Popper from 'vue3-popper';

const popperStatus = ref('Copy');
const activePopper = ref({});

const togglePopper = (index, status) => {
  activePopper.value[index] = status;
};

const copyToClipboard = async (value) => {
  try {
    await navigator.clipboard.writeText(value);
    popperStatus.value = 'Copied!';
    setTimeout(() => {
      popperStatus.value = 'Copy';
    }, 1500);
  } catch (err) {
    console.error('Cannot copy to clipboard:', err);
  }
};

defineProps({
  data: {
    type: Array,
    default: () => [],
  },
  title: {
    type: String,
    default: '',
  },
});

const icons = {
  email:
    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"> <path d="M2.66536 3.55713H13.332C14.0654 3.55713 14.6654 4.15713 14.6654 4.89046V12.8905C14.6654 13.6238 14.0654 14.2238 13.332 14.2238H2.66536C1.93203 14.2238 1.33203 13.6238 1.33203 12.8905V4.89046C1.33203 4.15713 1.93203 3.55713 2.66536 3.55713Z" stroke="#6D7181" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/> <path d="M14.6654 4.89062L7.9987 9.55729L1.33203 4.89062" stroke="#6D7181" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
  domain:
    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"><g clip-path="url(#clip0_7873_23860)"><path d="M16 8.27078C15.7662 6.33227 14.8156 4.55135 13.3352 3.2782C11.8548 2.00505 9.95167 1.33179 8 1.39078C6.04833 1.33179 4.14519 2.00505 2.66478 3.2782C1.18438 4.55135 0.233816 6.33227 0 8.27078L0 9.51078C0.233816 11.4493 1.18438 13.2302 2.66478 14.5034C4.14519 15.7765 6.04833 16.4498 8 16.3908C9.95167 16.4498 11.8548 15.7765 13.3352 14.5034C14.8156 13.2302 15.7662 11.4493 16 9.51078V8.27078ZM14.75 8.27078H11.75C11.7036 7.41053 11.5594 6.55837 11.32 5.73078C11.9451 5.47662 12.5337 5.14033 13.07 4.73078C13.9994 5.69374 14.5802 6.93979 14.72 8.27078H14.75ZM5.57 8.27078C5.61275 7.54584 5.73687 6.828 5.94 6.13078C6.61333 6.302 7.30524 6.38933 8 6.39078C8.70476 6.3912 9.40683 6.30386 10.09 6.13078C10.2891 6.82891 10.4132 7.54631 10.46 8.27078H5.57ZM10.49 9.51078C10.4481 10.2358 10.324 10.9538 10.12 11.6508C8.74823 11.3041 7.31177 11.3041 5.94 11.6508C5.73687 10.9536 5.61275 10.2357 5.57 9.51078H10.49ZM10.89 4.51078C10.6361 3.94838 10.3385 3.40672 10 2.89078C10.7167 3.11299 11.3922 3.45077 12 3.89078C11.6431 4.14842 11.2612 4.36953 10.86 4.55078L10.89 4.51078ZM8.29 2.65078C8.8512 3.352 9.31537 4.12562 9.67 4.95078C9.12203 5.07542 8.56196 5.13914 8 5.14078C7.438 5.13972 6.87787 5.07599 6.33 4.95078C6.68264 4.1246 7.14697 3.35072 7.71 2.65078H8.29ZM5.14 4.55078C4.73885 4.36953 4.35693 4.14842 4 3.89078C4.60777 3.45077 5.28333 3.11299 6 2.89078C5.66398 3.41712 5.37615 3.97271 5.14 4.55078ZM3 4.72078C3.53635 5.13033 4.12486 5.46662 4.75 5.72078C4.50768 6.54768 4.36335 7.4002 4.32 8.26078H1.32C1.46805 6.92602 2.05961 5.67952 3 4.72078ZM1.28 9.51078H4.28C4.32335 10.3714 4.46768 11.2239 4.71 12.0508C4.08486 12.3049 3.49635 12.6412 2.96 13.0508C2.01961 12.092 1.42805 10.8455 1.28 9.51078ZM5.14 13.2308C5.37615 13.8089 5.66398 14.3644 6 14.8908C5.28333 14.6686 4.60777 14.3308 4 13.8908C4.35693 13.6331 4.73885 13.412 5.14 13.2308ZM7.71 15.1308C7.14697 14.4308 6.68264 13.657 6.33 12.8308C7.42891 12.5773 8.57109 12.5773 9.67 12.8308C9.31804 13.6573 8.85366 14.4313 8.29 15.1308H7.71ZM10.86 13.2308C11.2784 13.409 11.6772 13.6302 12.05 13.8908C11.4391 14.3257 10.7644 14.663 10.05 14.8908C10.3641 14.3601 10.635 13.805 10.86 13.2308ZM13 13.0608C12.4637 12.6512 11.8751 12.3149 11.25 12.0608C11.4942 11.2343 11.6385 10.3816 11.68 9.52078H14.68C14.5319 10.8555 13.9404 12.102 13 13.0608Z" fill="#6D7181"/></g><defs><clipPath id="clip0_7873_23860"><rect width="16" height="16" fill="white" transform="translate(0 0.890625)"/></clipPath></defs></svg>',
  phone:
    '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none"><path d="M6.2008 15.5358C8.0957 16.6298 10.3476 16.9263 12.4611 16.36C12.8677 16.251 13.2629 16.1118 13.6437 15.9446C14.4765 15.5788 14.5776 14.5061 13.9517 13.8461L12.7302 12.558C12.0669 11.8585 10.9043 12.0665 10.5246 12.9525C10.1488 13.8294 9.00343 14.0445 8.33507 13.3638L5.84206 10.8247C5.19946 10.1702 5.31914 9.09084 6.0895 8.59303C6.86441 8.09228 6.98 7.00437 6.3276 6.35197L5.0937 5.11807C4.39629 4.42065 3.22784 4.57972 2.87981 5.50257C2.26355 7.1367 1.94922 9.00483 2.35691 10.5264C2.92322 12.6399 4.30591 14.4418 6.2008 15.5358Z" stroke="#6D7181" stroke-width="1.5"/></svg>',
  copy: '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"><path d="M11.168 11.8906V14.1406C11.168 14.5546 10.832 14.8906 10.418 14.8906H3.91797C3.71906 14.8906 3.52829 14.8116 3.38764 14.671C3.24699 14.5303 3.16797 14.3395 3.16797 14.1406V5.64063C3.16797 5.22663 3.50397 4.89063 3.91797 4.89063H5.16797C5.50302 4.8904 5.83751 4.91805 6.16797 4.97329M11.168 11.8906H13.418C13.832 11.8906 14.168 11.5546 14.168 11.1406V7.89063C14.168 4.91729 12.006 2.44996 9.16797 1.97329C8.83751 1.91805 8.50302 1.8904 8.16797 1.89063H6.91797C6.50397 1.89063 6.16797 2.22663 6.16797 2.64063V4.97329M11.168 11.8906H6.91797C6.71906 11.8906 6.52829 11.8116 6.38764 11.671C6.24699 11.5303 6.16797 11.3395 6.16797 11.1406V4.97329M14.168 9.39063V8.14063C14.168 7.54389 13.9309 6.97159 13.509 6.54964C13.087 6.12768 12.5147 5.89063 11.918 5.89063H10.918C10.7191 5.89063 10.5283 5.81161 10.3876 5.67096C10.247 5.5303 10.168 5.33954 10.168 5.14063V4.14063C10.168 3.84515 10.1098 3.55257 9.9967 3.27959C9.88362 3.00661 9.71789 2.75857 9.50896 2.54964C9.30003 2.3407 9.05199 2.17497 8.77901 2.0619C8.50602 1.94882 8.21344 1.89063 7.91797 1.89063H7.16797" stroke="#6D7181" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/></svg>',
};

const icon = (type) => icons[type] || '';
</script>
<template>
  <section class="border-color-body-color rounded-md border px-2 py-4">
    <p class="mb-4 text-left text-xs text-body-color">
      {{ title }}
    </p>
    <section v-if="data.length === 0">
      <p
        class="rounded-md border border-light-gray bg-off-white py-4 text-xs text-body-color"
      >
        No known {{ title.toLowerCase() }}
      </p>
    </section>
    <section
      v-for="(info, idx) in data"
      v-else
      :key="`${idx}-rate-card`"
      class="border-color-body-color flex items-center justify-between border-l border-r p-2"
      :class="{
        'rounded-t-lg border-t': idx === 0,
        'rounded-b-lg border-b': idx === data.length - 1,
        'bg-off-white': idx % 2 === 1,
      }"
    >
      <div class="flex gap-1">
        <div v-html="icon(info.type)" />
        <p
          class="text-xs"
          style="margin-top: 1px"
        >
          {{ info.value }}
        </p>
      </div>
      <popper
        v-if="info.type !== 'email'"
        :show="activePopper[idx]"
        placement="top"
        :arrow="true"
        offset-distance="6"
        @click="copyToClipboard(info.value)"
        @mouseenter="togglePopper(idx, true)"
        @mouseleave="togglePopper(idx, false)"
      >
        <div
          class="cursor-pointer hover:rounded-sm hover:bg-light-gray"
          v-html="icon('copy')"
        />
        <template #content>
          <div
            class="hidden rounded-md bg-dark-gray p-1 text-light-gray shadow-md lg:block"
          >
            <p class="text-2xs">
              {{ popperStatus }}
            </p>
          </div>
        </template>
      </popper>
    </section>
  </section>
</template>
